// extracted by mini-css-extract-plugin
export default {"card-about":"CardAbout_card-about__TS2bG"};